import { ErrorUI } from "../shared/error-ui";
import { useTranslation } from "react-i18next";

export interface CheckoutErrorProps {
  error?: Error | string | null;
  title?: string;
  description?: string;
}

export default function CheckoutError({
  error,
  title,
  description,
}: CheckoutErrorProps) {
  const { t } = useTranslation();
  const errorObj = error instanceof Error ? error : undefined;
  const errorMessage = error instanceof Error ? error.message : error;
  const displayDescription =
    description || errorMessage || t("errors.unknown");

  return (
    <ErrorUI
      title={title || t("errors.title")}
      description={displayDescription}
      error={errorObj}
    />
  );
}
